import React, { FC, useEffect, useRef, useState } from 'react';

import classNames from 'classnames';

import { DadataList } from '@widgets/AddPayments/ui/AddPartnerModal/DadataList/DadataList';

import cls from './TextInput.module.css';

export const Input = ({
    title,
    isRequired,
    placeholder = '',
    value,
    onChange,
    name,
    button = null,
    icon = null,
    isDisabled = false,
    type = 'text',
    error = null,
    isDadata = false,
    dadataList = [],
    setDatalist = () => {},
    dadataHandler = () => {},
    rightIcon = null,
    buttonHandler = () => {},
    isGroup = false,
    isFirstItemGroup = false,
    onFocus = false,
    autofocus = false,
    setIsFocused = () => {},
}) => {
    const ref = useRef();
    const inputWrapperRef = useRef(null);
    const [dadataStyle, setDadataStyle] = useState({});

    useEffect(() => {
        if (autofocus) {
            setIsFocused(true);
            ref.current?.focus();
        }
    }, [autofocus]);

    useEffect(() => {
        const calcRect = () => {
            if (!isDadata || !dadataList.length) {
                setDadataStyle({});
                return;
            }

            if (!inputWrapperRef.current) return;

            const rect = inputWrapperRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            const openUpward = spaceBelow < 170;

            setDadataStyle({
                position: 'fixed',
                top: openUpward ? rect.top - 8 : rect.bottom + 4,
                left: rect.left,
                width: rect.width,
                transform: openUpward ? 'translateY(-100%)' : 'none',
            });
        };

        calcRect();

        window.addEventListener('resize', calcRect);
        window.addEventListener('scroll', calcRect, true);

        return () => {
            window.removeEventListener('resize', calcRect);
            window.removeEventListener('scroll', calcRect, true);
        };
    }, [dadataList.length, isDadata]);

    return (
        <div className={classNames(cls.formBlockContent, { [cls.disabled]: isDisabled })}>
            {isDadata && !!dadataList.length && (
                <div className={classNames(cls.dadata)} style={dadataStyle}>
                    <DadataList dadataHandler={dadataHandler} dadataList={dadataList} />
                </div>
            )}
            {title && (
                <label className={classNames(cls.modalLabelSelect)}>
                    {title}
                    {isRequired && <span>*</span>}
                </label>
            )}
            <div className={classNames(cls.inputWrapper)} ref={inputWrapperRef}>
                {rightIcon && <div className={classNames(cls.right)}>{rightIcon}</div>}
                <input
                    ref={ref}
                    onFocus={onFocus ? onFocus() : null}
                    onBlur={() => {
                        if (isDadata) {
                            setTimeout(() => {
                                setDatalist([]);
                            }, 300);
                        }
                    }}
                    name={name}
                    onChange={onChange}
                    type={type}
                    className={classNames(cls.input, {
                        [cls.isGroup]: isGroup,
                        [cls.isFirstItemGroup]: isFirstItemGroup,
                    })}
                    placeholder={placeholder || title}
                    value={value}
                    disabled={isDisabled}
                    min={type === 'number' ? 0 : null}
                />

                {icon && <div className={classNames(cls.inputIcon)}>{icon}</div>}
                {button && (
                    <div onClick={buttonHandler} className={classNames(cls.inputButton)}>
                        {button}
                    </div>
                )}
            </div>
            {error && <span className={classNames(cls.errorMessage)}>{error}</span>}
        </div>
    );
};
